{
  "REGISTER": {
    "TRY_WOOT": "Izradite račun",
    "TITLE": "Registracija",
    "TESTIMONIAL_HEADER": "Dovoljan je jedan korak za napredak",
    "TESTIMONIAL_CONTENT": "Samo ste jedan korak od toga da angažirate svoje kupce, zadržite ih i pronađete nove.",
    "TERMS_ACCEPT": "Izradom računa prihvaćate naše <a href=\"https://chat.jarabot.com/terms\">Uvjete korištenja</a> i <a href=\"https://chat.jarabot.com/privacy-policy\">Politiku privatnosti</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Uvjeti korištenja</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Politika privatnosti</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Registrirajte se putem Googlea"
    },
    "COMPANY_NAME": {
      "LABEL": "Naziv tvrtke",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "Puno ime",
      "PLACEHOLDER": "Enter your full name. eg: Bruce Wayne",
      "ERROR": "Full name is too short"
    },
    "EMAIL": {
      "LABEL": "Poslovna e-pošta",
      "PLACEHOLDER": "Unesite svoju poslovnu adresu e-pošte. Npr. bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Lozinka",
      "PLACEHOLDER": "Lozinka",
      "ERROR": "Password is too short",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm Password",
      "PLACEHOLDER": "Confirm Password",
      "ERROR": "Password doesnot match"
    },
    "API": {
      "SUCCESS_MESSAGE": "Registracija uspješna",
      "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
    },
    "SUBMIT": "Izradi račun",
    "HAVE_AN_ACCOUNT": "Već imate račun?"
  }
}
